export enum States {
    inputMedia,selectSubject,uploading,ready
}